import { Routes } from '@angular/router';

export const PESO_MEDIO_ROUTES: Routes = [
	{
		path: 'peso-medio',
		loadComponent: () => import('./feature-peso-medio/peso-medio').then((m) => m.PesoMedio),
		data: { title: 'Peso médio' },
	},
];
